var r=-1;export{r as TAB_INDEX_FOCUS_WITH_JS_ONLY};
//# sourceMappingURL=MenuItemConstants.js.map
